import { setContext } from "@apollo/client/link/context";

const authLink = setContext((_, { headers }) => {
  // get the access token from session storage if it exists
  const token = sessionStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export default authLink;
